import React from "react";
import { useRoutes } from "react-router-dom";
import { Helmet, HelmetProvider } from "@dr.pogodin/react-helmet";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

import createTheme from "./theme";
import routes from "./routes";

import useTheme from "./hooks/useTheme";
import createEmotionCache from "./utils/createEmotionCache";
import { SnackbarProvider } from "notistack";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useOpenObserveInit } from "./hooks/useOpenObserveInit";
import { useIsCompanyOneSolomonsFromSearch } from "./pages/order/oneSolomonUi";
// trigger gha 5
const queryClient = new QueryClient();

const clientSideEmotionCache = createEmotionCache();

// const observer = new PerformanceObserver((list) => {
//   for (const entry of list.getEntriesByType("measure")) {
//     console.log(
//       `[${entry.name}] handled took ${entry.duration.toFixed(2)}ms`,
//       entry.toJSON()
//     );
//   }
// });
//
// observer.observe({ entryTypes: ["measure"] });

function App({ emotionCache = clientSideEmotionCache }) {
  const content = useRoutes(routes);

  const { theme } = useTheme();
  const isCompanyOneSolomons = useIsCompanyOneSolomonsFromSearch();

  useOpenObserveInit();

  return (
    <CacheProvider value={emotionCache}>
      <HelmetProvider>
        <Helmet
          titleTemplate={isCompanyOneSolomons ? "%s" : "%s | Aldrin ERP"}
          defaultTitle={isCompanyOneSolomons ? "ONESOLOMON" : "Aldrin ERP"}
        />
        <MuiThemeProvider theme={createTheme(theme)}>
          <SnackbarProvider maxSnack={6}>
            <QueryClientProvider client={queryClient}>
              {content}
            </QueryClientProvider>
          </SnackbarProvider>
        </MuiThemeProvider>
      </HelmetProvider>
    </CacheProvider>
  );
}

export default App;
